import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  HiOutlineHome,
  HiOutlineClock,
  HiOutlineTrendingUp,
  HiOutlineDesktopComputer,
  HiOutlineHeart,
  HiOutlineUserGroup,
  HiOutlineBriefcase,
  HiOutlineClipboardList,
  HiOutlineSupport,
  HiOutlineCode
} from 'react-icons/hi';

function RecruitPage() {
  const benefits = [
    { title: 'オールリモート', icon: <HiOutlineHome />, description: '場所を選ばない働き方。自宅でもカフェでも、パフォーマンスが出せる環境ならどこでも。通勤時間をゼロにし、仕事に集中できる環境を整えています。' },
    { title: 'フレックス制度', icon: <HiOutlineClock />, description: '時間に縛られるのではなく、成果で評価されるスタイル。自分のリズムで最大のパフォーマンスを発揮してください。' },
    { title: '成果連動型報酬', icon: <HiOutlineTrendingUp />, description: '固定給に加え、成果に応じたインセンティブを用意しています。あなたの貢献が、そのまま報酬に反映される仕組みです。' },
    { title: 'AI環境の完備', icon: <HiOutlineDesktopComputer />, description: '1人1アカウントのAIツールを支給。音声入力ツールも支給し、テクノロジーを最大限活用できる環境を整備しています。' },
    { title: 'ジム手当', icon: <HiOutlineHeart />, description: 'リモートワークで不足しがちな運動を支援。ジム費用を会社が負担し、心身ともに健康な状態で働ける環境をサポートします。' },
    { title: 'リワード会', icon: <HiOutlineUserGroup />, description: '月に1回、成果を称え合うお疲れ会を実施。リモートだからこそ、メンバー同士のつながりを大切にしています。' },
  ];

  const positions = [
    { title: 'プロジェクトマネージャー', icon: <HiOutlineBriefcase />, description: 'クライアントの事業成長を設計し、プロジェクト全体を統括するポジション。戦略立案からチームマネジメントまで、事業の中核を担います。' },
    { title: 'サブディレクター', icon: <HiOutlineClipboardList />, description: 'プロジェクトマネージャーと連携し、施策の実行・進行管理を担当。クライアントとの日常的なコミュニケーションや、各種施策のディレクションを行います。' },
    { title: 'アシスタント', icon: <HiOutlineSupport />, description: 'データ整理、レポート作成、各種調査など、プロジェクトの推進をサポートするポジション。未経験からでもマーケティングの実務を学べる環境です。' },
    { title: 'RPAエンジニア', icon: <HiOutlineCode />, description: '業務自動化の設計・開発を担当。マーケティングロジックをプログラムに落とし込み、クライアントの業務効率化を技術面から支えます。' },
  ];

  return (
    <div className="recruit-page">
      {/* Hero Section */}
      <section className="recruit-hero">
        <div className="hero-bg-image" style={{ backgroundImage: 'url(/images/hero-recruit.png)' }}></div>
        <div className="recruit-hero-overlay"></div>
        <Container>
          <div className="hero-content">
            <h1 className="page-title">Recruit</h1>
            <p className="page-subtitle">採用情報</p>
          </div>
        </Container>
      </section>

      {/* Message Section */}
      <section className="section-recruit-message">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2 className="section-label">Message</h2>
              <h3 className="recruit-headline">
                私たちと一緒に、事業の成長を設計しませんか。
              </h3>
              <div className="recruit-message-content">
                <p>
                  PerfTechは、クライアントの事業成長に成果連動型でコミットするグロースパートナーです。
                  広告代理店のような「運用の代行」ではなく、事業そのものの成長を設計する。
                  その実現のために、一人ひとりが高い専門性と主体性を持って働ける環境を整えています。
                </p>
                <p>
                  リモートワーク、フレックス、AI活用。
                  すべては「働く場所や時間」ではなく「成果と価値」にフォーカスするための仕組みです。
                  自分のスキルを最大限に活かしながら、クライアントの事業に本気で向き合える。
                  そんな働き方を一緒に実現しませんか。
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Culture & Benefits */}
      <section className="section-recruit-benefits">
        <Container>
          <h2 className="section-label">Culture &amp; Benefits</h2>
          <p className="section-description-text">PerfTechの環境と制度</p>
          <div className="recruit-benefits-grid">
            {benefits.map((benefit, index) => (
              <div className="recruit-benefit-card" key={index}>
                <div className="recruit-benefit-icon">{benefit.icon}</div>
                <h4>{benefit.title}</h4>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Member's Voice */}
      <section className="section-recruit-voice">
        <Container>
          <h2 className="section-label">Member's Voice</h2>
          <p className="section-description-text">社員の声</p>
          <Row className="justify-content-center">
            <Col lg={8}>
              <div className="recruit-voice-card">
                <div className="voice-profile">
                  <div className="voice-initial">T.N</div>
                  <div className="voice-info">
                    <p className="voice-name">T.Nさん</p>
                    <p className="voice-role">アシスタント</p>
                  </div>
                </div>
                <div className="voice-content">
                  <p>
                    PerfTechに入社する前は、フルタイムの出社勤務で働いていました。
                    転職のきっかけは、場所や時間にとらわれずに働ける環境を探していたことです。
                  </p>
                  <p>
                    入社してまず驚いたのは、AIツールが当たり前のように業務に組み込まれていること。
                    音声入力でメモを取り、AIがドラフトを作成し、それをチェック・修正していく。
                    以前の職場では考えられなかったスピード感で仕事が進みます。
                  </p>
                  <p>
                    リモートワークは最初は不安もありましたが、成果で評価してもらえるので、
                    自分のペースで集中して働けるのが合っていました。
                    月1回のリワード会でメンバーと顔を合わせるのも、良いリフレッシュになっています。
                  </p>
                </div>
                <div className="voice-schedule">
                  <h5>1日のスケジュール例</h5>
                  <div className="schedule-items">
                    <div className="schedule-item">
                      <span className="schedule-time">9:00</span>
                      <span className="schedule-task">業務開始・メール・チャット確認</span>
                    </div>
                    <div className="schedule-item">
                      <span className="schedule-time">9:30</span>
                      <span className="schedule-task">データ整理・レポート作成</span>
                    </div>
                    <div className="schedule-item">
                      <span className="schedule-time">12:00</span>
                      <span className="schedule-task">昼休憩</span>
                    </div>
                    <div className="schedule-item">
                      <span className="schedule-time">13:00</span>
                      <span className="schedule-task">クライアント関連の調査・資料作成</span>
                    </div>
                    <div className="schedule-item">
                      <span className="schedule-time">15:00</span>
                      <span className="schedule-task">チームミーティング</span>
                    </div>
                    <div className="schedule-item">
                      <span className="schedule-time">16:00</span>
                      <span className="schedule-task">翌日のタスク整理・業務終了</span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Open Positions */}
      <section className="section-recruit-positions">
        <Container>
          <h2 className="section-label">Open Positions</h2>
          <p className="section-description-text">募集職種</p>
          <div className="recruit-positions-grid">
            {positions.map((position, index) => (
              <div className="recruit-position-card" key={index}>
                <div className="recruit-position-icon">{position.icon}</div>
                <h4>{position.title}</h4>
                <p>{position.description}</p>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* CTA */}
      <section className="section-cta">
        <Container>
          <h2>あなたのスキルを、事業の成長に活かしませんか。</h2>
          <p className="cta-sub">
            私たちは、指示を待つのではなく、自ら考え行動できる方を求めています。
            経験やスキルだけでなく、事業の成長に本気で向き合える姿勢を大切にしています。
            まずはお気軽にご連絡ください。
          </p>
          <Link to="/recruit/apply" className="btn-primary-custom">
            エントリーする
          </Link>
        </Container>
      </section>
    </div>
  );
}

export default RecruitPage;
